import { useCallback } from 'react';

import { useRequirementState } from './useRequirementState';
import { ClientDataType } from '../../types';

export const useRequirementDataTypeState = () => {
  const {
    requirement: { dataType: requirementDataType },
    setRequirement,
  } = useRequirementState();
  const setRequirementDataType = useCallback(
    (newDataType?: ClientDataType) =>
      setRequirement((requirement) => ({ ...requirement, dataType: newDataType })),
    [setRequirement],
  );
  return {
    requirementDataType,
    setRequirementDataType,
  };
};
